export default __webpack_public_path__ + "static/media/alifa.3cfdec10.png";